
import ColorBreak from './game'

  const canvas = document.getElementById('game-canvas');

  new ColorBreak(canvas);
  
